import type { ProductType } from '@atlassian/dynamic-cards-search-client';

import { type ProductKeys, products } from '../constants/products';

/**
 * Get product display name from product key
 * @param type product key
 * @returns product display name
 */
export const getProductDisplayName = (type?: ProductType): "" | "Atlas" | "Confluence" | "Jira" | "Trello" | "Compass" | "Google Drive" | "GitHub" | "Microsoft SharePoint" => {
	switch (type) {
		case 'jira':
			return 'Jira';
		case 'confluence':
			return 'Confluence';
		case 'townsquare':
			return 'Atlas';
		case 'drive':
			return 'Google Drive';
		case 'microsoft':
		case 'sharepoint':
			return 'Microsoft SharePoint';
		case 'github':
			return 'GitHub';
		case 'compass':
			return 'Compass';
		case 'trello':
			return 'Trello';
	}
	return '';
};

/**
 * Given a product key, returns whether or not a product is a 3P
 * @param product
 * @returns Whether or not a product is a 3P
 */
export const isProduct3P = (product: ProductKeys): boolean | undefined => {
	return products[product].is3P;
};
